module.exports = __webpack_public_path__ + "static/media/present.eb7c714d.jpg";